import React, { MutableRefObject, useRef, useState } from 'react';

type TypeOfReference = null | number | React.Component<unknown, unknown> | React.ComponentClass<unknown>;

/**
 * Custom hook to handle state with ref.
 * This is convenient to use with DOM callbacks (setTimeout, setInterval)
 */

export const useIndexedStateReference = <T extends TypeOfReference = TypeOfReference>(initialState = {}): Return<T> => {
  const [, _setState] = useState<T | Record<number, T>>(initialState);
  const stateReference = useRef<Record<number, T>>(initialState);

  const setState = (newState: T, index: number) => {
    stateReference.current[index] = newState;
    _setState(newState);
  };

  const getState = () => stateReference.current;

  return [stateReference, getState, setState];
};

type Return<T> = [MutableRefObject<Record<number, T>>, () => Record<number, T>, (newState: T, index: number) => void];
